<div class="mt-4 swiper swiper-recruiterslogo">
        <div class="swiper-wrapper">
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/persistent.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/accenture.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/delta.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hexaware.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosys.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hcl.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sterlite.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tal.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tata-elxsi.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcl.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcs.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hsbc.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/dxc.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/adani.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/amazon.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ambuja-cement.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/apollo-tyres.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ashok-layland.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bajaj-allianz.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bosch.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/bajaj-finserv.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/capgemini.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/cognizant.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/conexant.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/essar.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/gmmco.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/godrej.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hexaware.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hcl.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/hsbc.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ibm.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/icici-bank.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infocepts.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosprectrum.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/infosys.webp"
                                                alt="Recrulasrs" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/ispat.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/itc-infotech.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/jio.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/jsw.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/kirloskar.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/kone.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/l&t-infotech.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/larsen-toubro.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mahindara.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mico.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/mk-schomburg.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/oracle.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reliance.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reliance-info.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sasken.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/reva.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/sintex.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/soma.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/zensar.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tal.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tata-elxsi.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcl.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
                <div class="swiper-slide">
                        <div class="grid-container">
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tcs.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/tech-mahindra.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" /></div>
                                <div class="item"><img
                                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/recruiters/wipro.webp"
                                                alt="Recruiters | GHRCACS" title="Recruiters" />
                                </div>
                        </div>
                </div>
        </div>
</div>
